function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import React, { useMemo } from 'react';
import classnames from 'classnames';
import { kebabCase } from 'lodash';
import AddFromOptionsButton from './addFromOptionsButton';
import { convertToAbsolutePath } from '../utils';
import { enabledSelector, valueSelector, labelSelector, newPathSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import logValueOnChange from '../commonActions/logValueOnChange';
const AddButton = ({
  enabled,
  contentPath,
  groupedOptions: _groupedOptions = [],
  initialContent: _initialContent = null,
  optionsExclusionKey: _optionsExclusionKey = '',
  title,
  value: _value = {},
  parentContentPath,
  onChange
}) => {
  const classNames = useMemo(() => classnames('tqc-control', 't-rb-add-button', `t-ab-${kebabCase(title)}`), [title]);
  const handleAdd = async (event, newItem = {}) => {
    const addPath = convertToAbsolutePath(contentPath, parentContentPath);
    let newItemContent = _objectSpread({
      _created: moment().toISOString()
    }, newItem);
    if (_initialContent) {
      newItemContent = _objectSpread(_objectSpread({}, newItemContent), _initialContent);
    }
    const uuid = uuidV4().toUpperCase();
    const newDataPath = `${addPath}/${uuid}`;
    await onChange({
      path: newDataPath,
      value: newItemContent
    });
  };
  let button;
  if (_groupedOptions.length) {
    button = /*#__PURE__*/React.createElement(AddFromOptionsButton, {
      block: true,
      className: classNames,
      enabled: enabled,
      groupedOptions: _groupedOptions,
      onAdd: handleAdd,
      optionsExclusionKey: _optionsExclusionKey,
      title: title,
      value: _value
    });
  } else {
    button = /*#__PURE__*/React.createElement(Button, {
      block: true,
      className: classNames,
      disabled: !enabled,
      onClick: handleAdd
    }, title);
  }
  return button;
};
AddButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  contentPath: PropTypes.string.isRequired,
  parentContentPath: PropTypes.string.isRequired,
  groupedOptions: PropTypes.arrayOf(PropTypes.shape({})),
  initialContent: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
  optionsExclusionKey: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.shape({})
};
export { AddButton as UncomposedAddButton };
export default entityComposition(AddButton, [], {
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector
});